import sample from 'lodash.sample'
import times from 'lodash.times'

export interface IVocableGenerationConfig {
  numOfSyllables: number
  onsets: string[]
  nuclea: string[]
  codas: string[]
}

interface ISyllable {
  onset: string
  nucleus: string
  coda: string
}

function normalizeSyllables (syllables: ISyllable[]) {
  return syllables.reduce((prev: ISyllable[], current: ISyllable, index: number) => {
    if (prev.length > 0) {
      const last = prev.pop()!
      const { nucleus, coda } = last
      if (nucleus.length > 1 && coda.length > 1 && current.onset.startsWith(coda.slice(-1))) {
        return [...prev, { onset: last.onset, nucleus, coda }, current]
      }
      return [...prev, last, current]
    }
    return [...prev, current]
  }, [])
}

export function vocableToString (vocable: ISyllable[]) {
  return vocable.map((syllable) => syllable.onset + syllable.nucleus + syllable.coda).join('')
}

export function generateVocable ({ numOfSyllables, onsets, nuclea, codas }: IVocableGenerationConfig) {
  return normalizeSyllables(times(numOfSyllables, (n) => {
    return {
      onset: sample(onsets.length > 0 ? onsets : [''])!,
      nucleus: sample(nuclea) || '',
      coda: sample(codas.length > 0 ? codas : [''])!,
    }
  }))
}
